import React, { useState } from "react"
import { Link } from "react-router-dom"
import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap"
import logoDark from "../../assets/images/logo-dark.png"
import logoLight from "../../assets/images/logo-light.png"
import * as Yup from "yup"
import { useFormik } from "formik"
import API from "../../api/axios"
import { useNavigate } from "react-router-dom"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
const ChangePassword = props => {
  const [successMsg, setSuccessMsg] = useState("")
  const [errorMsg, setErrorMsg] = useState("")
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  })

  const togglePassword = field => {
    setShowPassword(prev => ({ ...prev, [field]: !prev[field] }))
  }

  const navigate = useNavigate()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },

    validationSchema: Yup.object({
      currentPassword: Yup.string().required(
        "Please enter your current password",
      ),

      newPassword: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")

        .required("Please enter a new password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
        .required("Please confirm your password"),
    }),
    onSubmit: async values => {
      try {
        setErrorMsg("")
        setSuccessMsg("")
        const token = localStorage.getItem("authToken")

        const res = await API.post(
          "/users/change-password",
          {
            currentPassword: values.currentPassword,

            currentPassword: values.currentPassword,

            newPassword: values.newPassword,
            confirmPassword: values.confirmPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        setSuccessMsg(res.data.message)
        props.setBreadcrumbItems("Change-Password", breadcrumbItems)
        setTimeout(() => {
          localStorage.removeItem("authToken")
          navigate("/login")
        }, 1500)
        validation.resetForm()
      } catch (err) {
        setErrorMsg(err.response?.data?.message || "Something went wrong")
      }
    },
  })

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "change-password", link: "#" },
  
  ]
  return (
    <div className="account-pages my-3 pt-sm-4">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <Card className="overflow-hidden">
              <CardBody className="pt-0">
                <h3 className="text-center mt-5 mb-4">
                  <Link to="/" className="d-block auth-logo">
                    <img
                      src={logoDark}
                      alt=""
                      height="30"
                      className="auth-logo-dark"
                    />
                    <img
                      src={logoLight}
                      alt=""
                      height="30"
                      className="auth-logo-light"
                    />
                  </Link>
                </h3>

                <div className="p-3">
                  <h4 className="text-muted font-size-18 mb-3 text-center">
                    Change Password
                  </h4>

                  {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                  {successMsg && <Alert color="success">{successMsg}</Alert>}

                  <form
                    className="form-horizontal mt-4"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    {/* Current Password */}

                    <div className="mb-3">
                      <Label htmlFor="currentPassword">Current Password</Label>
                      <InputGroup>
                        <Input
                          name="currentPassword"
                          type={showPassword.current ? "text" : "password"}
                          placeholder="Enter current password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.currentPassword || ""}
                          invalid={
                            validation.touched.currentPassword &&
                            !!validation.errors.currentPassword
                          }
                        />
                        <InputGroupText
                          onClick={() => togglePassword("current")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`mdi ${showPassword.current ? "mdi-eye-off" : "mdi-eye"}`}
                          />
                        </InputGroupText>
                      </InputGroup>
                      {validation.touched.currentPassword &&
                        validation.errors.currentPassword && (
                          <FormFeedback type="invalid">
                            {validation.errors.currentPassword}
                          </FormFeedback>
                        )}
                    </div>

                    {/* New Password */}
                    <div className="mb-3">
                      <Label htmlFor="newPassword">New Password</Label>
                      <InputGroup>
                        <Input
                          name="newPassword"
                          type={showPassword.new ? "text" : "password"}
                          placeholder="Enter new password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.newPassword || ""}
                          invalid={
                            validation.touched.newPassword &&
                            !!validation.errors.newPassword
                          }
                        />
                        <InputGroupText
                          onClick={() => togglePassword("new")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`mdi ${showPassword.new ? "mdi-eye-off" : "mdi-eye"}`}
                          />
                        </InputGroupText>
                      </InputGroup>
                      {validation.touched.newPassword &&
                        validation.errors.newPassword && (
                          <FormFeedback type="invalid">
                            {validation.errors.newPassword}
                          </FormFeedback>
                        )}
                    </div>

                    {/* Confirm Password */}
                    <div className="mb-3">
                      <Label htmlFor="confirmPassword">Confirm Password</Label>
                      <InputGroup>
                        <Input
                          name="confirmPassword"
                          type={showPassword.confirm ? "text" : "password"}
                          placeholder="Confirm new password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmPassword || ""}
                          invalid={
                            validation.touched.confirmPassword &&
                            !!validation.errors.confirmPassword
                          }
                        />
                        <InputGroupText
                          onClick={() => togglePassword("confirm")}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`mdi ${showPassword.confirm ? "mdi-eye-off" : "mdi-eye"}`}
                          />
                        </InputGroupText>
                      </InputGroup>
                      {validation.touched.confirmPassword &&
                        validation.errors.confirmPassword && (
                          <FormFeedback type="invalid">
                            {validation.errors.confirmPassword}
                          </FormFeedback>
                        )}
                    </div>

                    <Row className="mb-3">
                      <div className="col-12 text-end">
                        <button className="btn btn-primary w-md" type="submit">
                          Change Password
                        </button>
                      </div>
                    </Row>
                  </form>
                </div>
              </CardBody>
            </Card>
         
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default connect(null, { setBreadcrumbItems })(ChangePassword)
